<template>
  <div class="carousel-navigation-component">
    <button
      class="arrow-button"
      :disabled="activeIndex === 0"
      @click="$emit('navigate', activeIndex - 1)"
    >
      <icon
        class="arrow-icon"
        name="mastery-arrow-left"
        variant="b2b2b2"
        :class="{ first: activeIndex === 0 }"
      />
    </button>
    <button
      v-for="i in length"
      :key="i"
      :class="['dot-button', { active: i - 1 == activeIndex }]"
      @click="$emit('navigate', i - 1)"
    />
    <button
      class="arrow-button"
      :disabled="activeIndex === length - 1"
      @click="$emit('navigate', activeIndex + 1)"
    >
      <icon
        class="arrow-icon"
        name="mastery-arrow-right"
        variant="b2b2b2"
        :class="{ last: activeIndex === length - 1 }"
      />
    </button>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  name: 'CarouselNavigation',
  components: { Icon },
  props: {
    activeIndex: {
      type: Number,
    },
    length: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
  .carousel-navigation-component {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: rem-calc(40) 0 rem-calc(18);

    @include breakpoint(small) {
      margin: rem-calc(16) 0 0;
    }

    .dot-button {
      background: black;
      border-radius: 100%;
      height: rem-calc(7);
      margin: 0 rem-calc(4);
      opacity: 0.3;
      padding: 0;
      width: rem-calc(7);

      &.active {
        opacity: 1.0;
      }
    }

    .arrow-button {
      background: transparent;
      padding: 0;

      @include breakpoint(small) {
        display: none;
      }

      &:first-child {
        margin-right: rem-calc(32);
      }

      &:last-child {
        margin-left: rem-calc(32);
      }

      .arrow-icon {
        height: rem-calc(14);
        width: rem-calc(14);

        &.first, &.last {
          visibility: hidden;
        }
      }
    }
  }
</style>